module.exports = __webpack_public_path__ + "img/VR.4fcba899.png";